import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../Blog.css';

const AdminPosts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [message, setMessage] = useState('');

  const getApiUrl = (endpoint) => {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
    return isLocal ? `http://${window.location.hostname}:3001${endpoint}` : endpoint;
  };

  const fetchPosts = async () => {
    try {
      const response = await fetch(getApiUrl('/api/blog'));
      if (response.ok) {
        const data = await response.json();
        const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setPosts(sortedData);
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleEdit = (post) => {
    navigate(`/admin/posts/edit/${post.id}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm(t('blog.confirmDelete'))) return;
    
    const token = localStorage.getItem('token');
    if (!token) {
        navigate('/login');
        return;
    }

    try {
      const response = await fetch(getApiUrl(`/api/blog/${id}`), {
        method: 'DELETE',
        headers: { 
            'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        setMessage(t('blog.deleteSuccess'));
        fetchPosts();
      } else {
        const data = await response.json();
        setMessage(data.error || 'Error');
      }
    } catch (error) {
      setMessage('Network Error');
    }
  };

  return (
    <div>
      <h2>{t('blog.allPosts')}</h2>
      {message && <p className="admin-message">{message}</p>}
      <div className="admin-post-list" style={{marginTop: '20px'}}>
        {posts.map(post => (
            <div key={post.id} className="admin-post-item" style={{border: '1px solid #eee', padding: '15px', marginBottom: '10px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff'}}>
                <div>
                    <strong>{post.title}</strong>
                    <span style={{display: 'block', fontSize: '0.8rem', color: '#888'}}>{post.date}</span>
                </div>
                <div>
                    <button className="btn" onClick={() => handleEdit(post)} style={{marginRight: '5px', backgroundColor: '#00bcd4', color: 'white'}}>{t('blog.edit')}</button>
                    <button className="btn" onClick={() => handleDelete(post.id)} style={{backgroundColor: '#ff5252', color: 'white'}}>{t('blog.delete')}</button>
                </div>
            </div>
        ))}
      </div>
    </div>
  );
};

export default AdminPosts;